module.exports = __webpack_public_path__ + "static/abachi_logo-9297acd5aeabc3a9c8cb37a4862a4e69.png";